module.exports = __webpack_public_path__ + "img/q_bg.5255bea2.png";